import React, { useEffect, createElement } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { AboutSection } from './components/AboutSection';
import { ProcessSection } from './components/ProcessSection';
import { FloridaSection } from './components/FloridaSection';
import { ServicesSection } from './components/ServicesSection';
import { AlliancesSection } from './components/AlliancesSection';
import { PortfolioSection } from './components/PortfolioSection';
import { ProofSection } from './components/ProofSection';
import { ReviewsSection } from './components/ReviewsSection';
import { RiskReversalSection } from './components/RiskReversalSection';
import { FAQSection } from './components/FAQSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
import { PromoPopup } from './components/PromoPopup';
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '2433320707143614');
      fbq('track', 'PageView');
      fbq('track', 'ViewContent', {
        content_name: 'Inkova Services',
        content_category: 'Business Consulting'
      });
    `;
    document.head.appendChild(script);
    // noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=2433320707143614&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.head.appendChild(noscript);
  }, []);
  return <div className="min-h-screen bg-white font-sans selection:bg-inkova-accent selection:text-inkova-primary" data-id="element-0">
      <PromoPopup data-id="element-1" />
      <Navbar data-id="element-2" />
      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <PainSection data-id="element-5" />
        <AboutSection data-id="element-6" />
        <ProcessSection data-id="element-7" />
        <FloridaSection data-id="element-8" />
        <ServicesSection data-id="element-9" />
        <AlliancesSection data-id="element-10" />
        <PortfolioSection data-id="element-11" />
        <ProofSection data-id="element-12" />
        <ReviewsSection data-id="element-13" />
        <RiskReversalSection data-id="element-14" />
        <FAQSection data-id="element-15" />
        <CTASection data-id="element-16" />
      </main>
      <Footer data-id="element-17" />
    </div>;
}